<template>
    <nav class="pages">
        <ul>
            <li v-for="index in options.length" :key="index">
                <button
                    @click="goTo(index - 1)"
                    :disabled="index - 1 > maxApplicableStep"
                    :class="[(index - 1 < currentIndex) ? 'complete' : '',(index -1 == currentIndex) ? 'active' : '']"
                    >
                    <span>{{ options[index - 1].label }}</span>
                </button>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    computed: {
        maxApplicableStep: {
            get() {
                let i = this.currentIndex
                while (this.selectedOptions[i] !== undefined && this.selectedOptions[i].length && this.name.length) {
                    i++
                }
                
                return i;
            }
        },
        currentIndex: {
            get() {
                return this.$store.state.currentIndex
            },
            set(value) {
                this.$store.commit('setCurrentIndex', { currentIndex: value })
            }
        },
        options: {
            get() {
                return this.$store.state.options
            }
        },
        selectedOptions: {
            get() {
                return this.$store.state.selectedOptions
            }
        },
        name: {
            get() {
                return this.$store.state.name
            }
        }
    },
    methods: {
        goTo(index) {
            index = parseInt(index)
            if (index >= 0 && index <= this.options.length) {
                console.log(index)
                for (let i = 0; i <= index; i++) {
                    if (this.selectedOptions[i] !== undefined && this.selectedOptions[i].length) {
                        this.$router.push({ path: '/step' + (index + 1) })
                    }
                }
            }
        }
    }
}
</script>